import { useEffect, useMemo } from 'react'
import { resetSessionId } from 'actions/CruiseActions'

import { getCruiseSearchStateFromParams } from 'lib/cruises/cruiseUtils'

import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import AnalyticsPageContext, { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'

import { useGlobalCruisesSearchContext } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalCruisesSearch'
import { useAppDispatch } from 'hooks/reduxHooks'
import useQueryParams from 'hooks/useQueryParams'

import Sheet from 'components/utils/Sheet'
import Group from 'components/utils/Group'

import CruiseHeadData from '../Common/CruiseHeadData'
import CruisePageSearchHero from './CruisePageSearchHero'
import CruisePageBrowseByPorts from './CruisePageBrowseByPorts'
import CruisePageContentSection from './CruisePageContentSection'
import useCruisePageContentOrder from './useCruisePageContentOrder'

function CruisesPage() {
  const dispatch = useAppDispatch()
  const queryParams = useQueryParams()
  const contentOrder = useCruisePageContentOrder()

  // oxlint-disable-next-line react-hooks/exhaustive-deps
  const initialSearchState = useMemo(() => getCruiseSearchStateFromParams(queryParams), [])
  const { globalCruisesSearchDispatch, globalCruisesSearchState } = useGlobalCruisesSearchContext({
    ...GLOBAL_SEARCH_INITIAL_STATE,
    ...initialSearchState,
  })

  useEffect(() => {
    dispatch(resetSessionId())
  }, [dispatch, globalCruisesSearchDispatch])

  return (
    <AnalyticsPageContext.Provider value={AnalyticsPage.verticalPage}>
      <CruiseHeadData />

      <GlobalSearchContextProvider
        state={globalCruisesSearchState}
        dispatch={globalCruisesSearchDispatch}
      >
        <CruisePageSearchHero />

        <Sheet padding="24 0">
          <Group direction="vertical" gap={56}>
            {contentOrder.map((contentName, index) => (
              <CruisePageContentSection
                key={contentName}
                contentName={contentName}
                isFirstContent={index === 0}
              />
            ))}

            <CruisePageBrowseByPorts />
          </Group>
        </Sheet>
      </GlobalSearchContextProvider>
    </AnalyticsPageContext.Provider>
  )
}

export default CruisesPage
